import { Component, OnInit } from '@angular/core';
import { createEmbeddingContext, EmbeddingContext } from 'amazon-quicksight-embedding-sdk';
import { StatisticheApiService } from 'src/api/statistiche-api.service';

@Component({
  selector: 'app-quicksight-sic-ania',
  templateUrl: './quicksight-sic-ania.component.html',
})
export class QuicksightSicAniaComponent implements OnInit {
  loadingError = false;
  dashboard: any;

  constructor(private statisticheApiService: StatisticheApiService) {}

  ngOnInit(): void {
    this.getDashboardURL();
  }

  public async getDashboardURL() {
    this.statisticheApiService
      .getQuickSightLinkForAnia()
      .then((data: any) => {
        console.log(data.embedUrl);
        this.Dashboard(data.embedUrl);
      })
      .catch((error: any) => {
        this.loadingError = true;
        console.error('Error fetching dashboard URL for Sic Ania:', error);
      });
  }

  public async Dashboard(embeddedURL: any) {
    console.log('embeddedURL', embeddedURL);
    const containerDiv = document.getElementById('dashboardContainerSicAnia') || '';
    const frameOptions = {
      url: embeddedURL,
      container: containerDiv,
      height: '850px',
      width: '100%',
      resizeHeightOnSizeChangedEvent: true,
    };
    const embeddingContext: EmbeddingContext = await createEmbeddingContext();
    this.dashboard = embeddingContext.embedDashboard(frameOptions);
  }
}
